export const OUTGOING_REBUZZ_PROPERTIES = {
  PRICE_POINTS: 'pricePoints',
  PRICE_CURRENCY: 'priceCurrency',
  BUDGET_AMOUNT: 'budgetAmount',
  BUDGET_PERIODICITY: 'budgetPeriodicity',
  BALANCE: 'balance',
};
